(function(){
  const linkShare = document.getElementById('link-share')
  const linkShareUrl = document.getElementById('link-share-url')

  if (linkShare) {
    linkShare.addEventListener('click', function(){
      linkShareUrl.select()
      // execCommand inside setTimeout because it sometimes doesn't run properly immediately after select()
      setTimeout(document.execCommand("copy"), 10)
      linkShare.classList.add('active')
      linkShare.classList.add('active2')
      setTimeout(function() {
        linkShare.classList.remove('active')
      }, 500)
      setTimeout(function() {
        if (linkShare.classList.contains('active2')) {
          linkShare.classList.remove('active2')
        }
      }, 2000)
    })
  }
})();
